import React from 'react';
import {Redirect} from 'react-router-dom';
import {useAuth} from "react-oidc-context";
import ApiClient from "../../../services/ApiClient";

export default function Logout() {
  const auth = useAuth();
  ApiClient.clearCaches();
  auth.signoutRedirect();
  return <Redirect to="/dashboard" />;
}
